import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  /** 表示するコンポーネントの種類 */
  type:
    | 'title'
    | 'titleSuccess'
    | 'titleFailure'
    | 'heading'
    | 'name'
    | 'price'
    | 'listMessage'
    | 'detailMessage';
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';

/**
 * タイトルコンポーネント
 */
export const Title: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  type,
  className,
  element: Element = DEFAULT_COMPONENT,
  ...props
}) => {
  const _clsName = className || type;
  return (
    <Element {...props} className={_clsName}>
      {props.children}
    </Element>
  );
};
Title.displayName = 'Title';
